import type { TimesheetWeek, TimesheetEntryInput } from "@/lib/api";

/**
 * Conversions between a timesheet week and the flat hours map the weekly grid
 * edits. Kept out of `WeeklyGrid.tsx` so that file exports only its component
 * and Fast Refresh keeps working (react-refresh/only-export-components).
 */

/** hours[taskKey][date] = hours. taskKey is the numeric task id as string. */
export type HoursMap = Record<string, Record<string, number>>;

export function buildHoursMap(week: TimesheetWeek): HoursMap {
  const map: HoursMap = {};
  for (const day of week.days) {
    for (const e of day.entries) {
      const key = String(e.task_id ?? "none");
      (map[key] ||= {})[day.date] = Number(e.hours);
    }
  }
  return map;
}

export function hoursMapToEntries(map: HoursMap): TimesheetEntryInput[] {
  const out: TimesheetEntryInput[] = [];
  for (const [taskKey, byDate] of Object.entries(map)) {
    for (const [date, hours] of Object.entries(byDate)) {
      if (hours > 0) {
        out.push({ entryDate: date, taskId: taskKey === "none" ? null : Number(taskKey), hours });
      }
    }
  }
  return out;
}
